export default {
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.name === 'xs';
    },

    isTablet() {
      return this.$vuetify.breakpoint.name === 'sm';
    },

    isMobileOrTablet() {
      return this.isMobile || this.isTablet;
    },

    isDesktop() {
      return !this.isMobileOrTablet;
    },
  },
};
